<template>
  <card title="Entites">
    <base-input
      label="Added entities"
      placeholder="Added entities"
      v-model="addedEntities"
    ></base-input>
    <base-input
      label="Rejected entities"
      placeholder="Rejected entites"
      v-model="rejectedEntities"
    ></base-input>
    <base-button class="btn btn-primary" type="simple" @click="send()"
      >Send entites</base-button
    >
  </card>
</template>

<script>
import { mapState } from "vuex";
import APIClinics from "@/api/modules/clinics";

export default {
  data() {
    return {
      addedEntities: "",
      rejectedEntities: ""
    };
  },
  computed: {
    ...mapState("clinics", ["clinic"])
  },
  methods: {
    async send() {
      if (!this.rejectedEntities?.length && !this.addedEntities?.length) {
        return this.$notify({
          type: "warning",
          title: "Please fill at least one field"
        });
      }
      const data = {
        added_entities: this.addedEntities,
        rejected_entities: this.rejectedEntities,
        clinic_id: this.clinic?.id
      };
      this.$store.dispatch("setLoader", true);
      try {
        await APIClinics.sendEntities(data);
        this.$notify({ type: "success", title: "Entities sent" });
        this.addedEntities = "";
        this.rejectedEntities = "";
      } catch (error) {
        this.$notify({ type: "warning", title: "Error" });
      } finally {
        this.$store.dispatch("setLoader", false);
      }
    }
  }
};
</script>
